module.exports = __webpack_public_path__ + "static/img/tool_service_4.58ab7b7c.png";